"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapElement = exports.RecaptchaElement = exports.injectScript = void 0;
function resolveLib() {
    var startWait = new Date();
    return new Promise(function (resolve, reject) {
        function poll() {
            if (window.grecaptcha !== undefined &&
                window.grecaptcha.render !== undefined) {
                resolve(window.grecaptcha);
            }
            else {
                var elapsedMs = new Date().valueOf() - startWait.valueOf();
                if (elapsedMs > 15000) {
                    reject(new Error('grecaptcha not loaded after 15 seconds'));
                }
                else {
                    setTimeout(poll, 250);
                }
            }
        }
        poll();
    });
}
function injectScript() {
    if (window.grecaptcha !== undefined) {
        throw new Error('grecaptcha is already defined');
    }
    var script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
}
exports.injectScript = injectScript;
var RecaptchaElement = (function () {
    function RecaptchaElement(container, params) {
        this.container = container;
        this.params = params;
        this.executeResolveQueue = [];
    }
    RecaptchaElement.prototype.render = function () {
        var _this = this;
        if (this.widgetId !== undefined) {
            console.warn('rendering an already-rendered widget');
        }
        resolveLib().then(function (lib) {
            _this.widgetId = lib.render(_this.container, __assign(__assign({}, _this.params), { callback: function (token) {
                    _this.resolvedToken = token;
                    _this.executeResolveQueue.pop()(token);
                } }));
        });
    };
    RecaptchaElement.prototype.resolveToken = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.executeResolveQueue.push(resolve);
            resolveLib().then(function (lib) {
                if (_this.resolvedToken !== undefined) {
                    _this.resolvedToken = undefined;
                    lib.reset(_this.widgetId);
                }
                lib.execute(_this.widgetId);
            });
        });
    };
    return RecaptchaElement;
}());
exports.RecaptchaElement = RecaptchaElement;
function wrapElement(container, sitekey, extraParams) {
    var params = __assign(__assign({}, (extraParams || {})), { sitekey: sitekey });
    var captcha = new RecaptchaElement(container, params);
    captcha.render();
    return captcha;
}
exports.wrapElement = wrapElement;
